import React, { useState, useEffect } from 'react';
import Sortable from 'react-sortablejs';

import { Search } from 'lucide-react';
import { FormSectionCollapsible, List, ListItem, Input } from 'twyne-new.ui';

import { sortableStore } from './utils'

export default class Palette extends React.Component {
  state = {
    search: '',
  }

  Sortable = sortableStore(({ children, onMove }) => <Sortable
    options={{
      ghostClass: "col",
      group: { name: "palette", put: false },
      sort: false,
      onMove,
      onAdd: () => onMove({ to: null, from: null }),
    }}
    onChange={(order, sorteable, evt) => {
      const { item: { dataset: { fieldIdx, groupIdx } } } = evt
      evt.data = this.props.data[groupIdx].fields[fieldIdx]
    }}
  >
    {children}
  </Sortable>)

  PaletteGroup = ({ group, groupIdx }) => {
    const filterSearch = fields => {
      const { selectedFields } = this.props
      const { search } = this.state

      let regex = ''
      try {
        regex = search && RegExp(search, 'i')
      } catch (error) { }

      return fields.filter(([{ field, label, value, hiddenBy }]) => {
        const isSelected = !!selectedFields[value]
        const isHidden = hiddenBy ? hiddenBy.some(field => !!selectedFields[field]) : false

        if (isSelected || isHidden) {
          return false
        }

        return regex ? regex.test(field) || regex.test(label) : true
      })
    }

    const fields = filterSearch(group.fields.map((field, fieldIdx) => [field, fieldIdx]))

    if (!fields.length) {
      return null
    }

    return <>
      <FormSectionCollapsible
        title={group.label}
        titleClass='text-md'
        contentClass='pb-2'
        defaultOpen
        border
        className='border-0'
        triggerClass='px-0 py-2'
      >
        <List className='px-0!'>
          <this.Sortable onChange={this.props.onChange}>
            {fields.map(([field, fieldIdx]) => <ListItem
              key={`${field.field}-${fieldIdx}`}
              data-field-idx={fieldIdx}
              data-group-idx={groupIdx}
              data-type="palette"
              className='mb-2 border twy-border-base'
            >
              {field.label || field.field}
            </ListItem>)}
          </this.Sortable>
        </List>
      </FormSectionCollapsible>
    </>
  }

  Search = () => {
    const [search, setSearch] = useState('')

    const handleSearch = evt => {
      setSearch(evt.target.value)
    }

    useEffect(() => {
      this.setState({ search })
    }, [search])

    return <>
      <div className='relative rounded-sm bg-gray-200 dark:bg-gray-950 mr-2 mb-2'>
        <Search size='18' className='absolute left-2 top-1/2 -translate-y-1/2 z-10 twy-text-base' />
        <Input
          name="filter"
          placeholder="Fields"
          className="border-0 w-full z-0 pl-8 bg-transparent"
          onChange={handleSearch}
          value={search}
        />
      </div>
    </>
  }

  render() {
    const { data } = this.props
    return <div className='pr-2 h-[calc(100vh-15.2rem)] flex flex-col'>
      <this.Search />
      <div className='flex-1 min-h-0 overflow-y-auto pr-2 mr-[-4px]'>
        {data.map((group, idx) => <this.PaletteGroup key={idx} group={group} groupIdx={idx} />)}
      </div>
    </div>
  }
}
